import { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";

export default function Counter({ to, duration = 1.8, className = "", ...rest }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const target = parseInt(String(to).replace(/\D/g, ""), 10) || 0;
  const suffix = String(to).replace(/[\d\s]/g, "");

  useEffect(() => {
    if (!inView || !ref.current) return;
    const ctrl = animate(0, target, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => {
        if (ref.current) ref.current.textContent = Math.round(v) + suffix;
      },
    });
    return () => ctrl.stop();
  }, [inView, target, duration, suffix]);

  return (
    <span ref={ref} className={className} {...rest}>
      0{suffix}
    </span>
  );
}
